<template>
  <div class="home-container">
    <div class="home-wrap">
      <div class="home-head">
        <h1>Acemap</h1>
        <h2>基金搜索</h2>
      </div>
      <div class="home-search">
        <div class="home-select">
           <el-cascader
              v-model="filterValue"
              :options="options"
              :props="props"
              collapse-tags
              @change="handleChange"
            ></el-cascader>
          </div>
        <div class="home-input">
          <el-input
            @keyup.enter.native="handleSearch"
            v-model="input"
            placeholder="Enter your keywords here and start exploring"
          >
          </el-input>
        </div>
        <div class="home-btn">
          <el-button type="primary" @click="handleSearch"
            ><i class="el-icon-search"></i> Search</el-button
          >
        </div>
        <div class="home-btn" style="margin-left: 10px;">
          <el-button type="primary" plain @click="routerPush('nsfc-search')"
            >高级检索</el-button
          >
        </div>
      </div>
      <div class="home-total">
        <div class="ht-item">
          <img src="./Data.png" alt="" />
          <div class="ht-item-sp">
            <span class="htis-big">{{ metadata }}</span>
            <span>元数据</span>
          </div>
        </div>
        <div class="ht-item">
          <img src="./Website.png" alt="" />
          <div class="ht-item-sp">
            <span class="htis-big">{{ scholar }}</span>
            <span>学者</span>
          </div>
        </div>
        <div class="ht-item">
          <img src="./Institution.png" alt="" />
          <div class="ht-item-sp">
            <span class="htis-big">{{ supporting_unit }}</span>
            <span>依托单位</span>
          </div>
        </div>
      </div>
      <ul class="link-list">
        <li v-for="item in linkList" :key="item.id" class="link-item" @click="routerPush(item.route)">
          <img :src="item.img" alt="" srcset="" />
          <div class="list-details">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
 
<script>
import geo from "./geo.png";
import nsfc from "./nsfc.png";
export default {
  data() {
    return {
      linkList: [
        {
          id: 1,
          img: geo,
          title: "信息学部 基金热词统计",
          desc: "",
          route: 'nsfckeywords'
        },
        {
          id: 2,
          img: nsfc,
          title: "地球科学部 基金热词统计",
          desc: "",
          route: 'geosciencekeywords'
        },
      ],
      filterValue: [],
      options: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'child',
        multiple: true
      },
      value: "All",
      input: "",
      scholar: 0,
      metadata: 0,
      supporting_unit: 0,
      ip: "",
      baseurl: 'https://nsfc.acemap.info/',
    };
  },
  mounted() {
    this.getfilter();
    this.getDiscipline();
    // this.visit()
  },
  updated() {
    //   window.location.reload()
  },
  methods: {
    goranking() {
      this.$router.push({
        name: "ranking",
        query: {
          key: this.input,
          sub: this.value,
        },
      });
    },
    gomap() {
      this.$router.push({
        name: "map",
        query: {
          key: this.input,
          sub: this.value,
        },
      });
    },
    visit() {
      // this.$axios
      //   .get("https://dataexpo.deep-time.org/api/v1/ip/visit?ip=" + returnCitySN["cip"])
      //   .then((response) => {});
      this.$axios
        .get("https://www.acemap.info/api/v2/ip/visit?ip=" + $ip)
        .then((response) => {});
    },

    handleclicktag(e) {
      this.$router.push({
        name: "ranking",
        query: {
          key: e,
          sub: this.value,
        },
      });
    },
    selectchange(e) {
      console.log(e, "---149");
    },
    getfilter() {
      // this.options = [];
      this.$axios
        // .get(this.baseurl + "api/v2/home/?cache_es=false&cache_version=1")
        .get(`${this.baseurl}api/v2/home/statistics`)
        .then((response) => {
          // for (let i = 0; i < response.data.subject_list.length; i++) {
          //   this.options.push({
          //     value: response.data.subject_list[i],
          //     label: response.data.subject_list[i],
          //   });
          // }
          const data = response.data.data;
          this.scholar = data.scholar;
          this.metadata = data.metadata;
          this.supporting_unit = data.supporting_unit;
          console.log("response.data", response.data);
        })
        .catch(() => {
          this.$notify.error({
            title: "Error",
            message: "Failed, please try again!",
          });
        });
    },
    getDiscipline() {
      this.$axios
        // .get(this.baseurl + "api/v2/home/?cache_es=false&cache_version=1")
        .get(`${this.baseurl}api/v2/home/discipline`)
        .then(res => {
          this.options = res.data.data || []
        })
    },
    handleChange() {},
    handleSearch() {
      console.log(this.filterValue)
      const filterQuery = this.filterValue.length ? this.filterValue.map(i => i[1]).join(',') : ''
      console.log('filterQuery', filterQuery)
      if (!this.input) {
        return
      }
      this.$router.push({
        name: 'search',
        query: {
          keyword: this.input,
          query: filterQuery
        }
      })
    },
    routerPush(name) {
      this.$router.push({
        name
      })
    }
  },
};
</script>

<style scope>
* {
  font-family: Source Sans Pro;
  box-sizing: border-box;
}
.home-container {
  margin: auto;
}
.home-wrap {
  width: 100%;
  padding-top: 120px;
  overflow: hidden;
  min-height: 100vh;
}
.home-head {
  /* width: 800px; */
  margin: 0 auto;
  text-align: center;
  position: relative;
  /* padding-top: 24px; */
}
.home-head h1 {
  font-size: 68px;
  font-weight: 900;
  color: #015ebe;
}
.home-head h2 {
  font-size: 32px;
  font-weight: 600;
  color: #015ebe;
}
.home-head img {
  width: 220px;
  float: left;
  position: absolute;
  top: -10px;
  left: -45px;
}
.home-head span {
  font-size: 40px;
  font-weight: bold;
  font-family: tahoma, arial, "Hiragino Sans GB", \5b8b\4f53, sans-serif;
}
.home-search {
  width: 900px;
  margin: 0 auto;
  display: flex;
  margin-top: 30px;
}
.home-input {
  flex: 1;
  margin: 0 20px;
}
.home-cy {
  width: 900px;
  margin: 0 auto;
  margin-top: 60px;
  height: 200px;
  overflow: hidden;
}
.home-select {
  width: 150px;
}
#wrap {
  position: relative;
  left: 40%;
  top: 200px;
  /*text-align: center;*/
}
#wrap .tag {
  display: inline-block;
  position: absolute;
  /*width: 50px;*/
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  text-decoration: none;
  cursor: pointer;
  /*left: 10px;*/
}
#wrap .tag:hover {
  font-weight: bold;
  opacity: 1;
  text-shadow: 1px 3px 3px rgba(0, 0, 0, 0.2);
}
</style>
<style>
.home-search .el-input__inner {
  height: 60px !important;
  line-height: 60px !important;
}
.home-search .el-button {
  height: 60px !important;
  line-height: 60px !important;
  padding: 0 20px !important;
  font-size: 20px !important;
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
}
.home-search .home-btn .el-button span {
  display: inline-block;
  margin-top: -2px;
}
.home-search .el-icon-search {
  font-size: 25px !important;
  line-height: 60px !important;
  color: #409eff !important;
}
.home-search span {
  font-weight: bold !important;
}
.home-search .el-input__prefix {
  left: 15px;
}
.home-input .el-input__inner {
  font-size: 18px !important;
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
}
.home-select .el-input__inner {
  font-size: 18px !important;
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
}
.home-total {
  width: 900px;
  margin: 50px auto;
  padding: 0 10px 0 50px;
  display: flex;
}
.home-total span {
  display: inline-block;
  margin-right: 10px;
}
.ht-item {
  flex: 1;
  text-align: center;
}
.ht-item img {
  width: 60px;
}
.ht-item-sp {
  display: block;
  vertical-align: top;
  margin-top: 10px;
  font-size: 14px;
}
.ht-item-sp span {
  display: inline-block;
  width: 100%;
  color: rgb(91, 155, 213);
}
.htis-big {
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 8px;
}
.home-search .home-btn .el-icon-search {
  color: white !important;
}
.home-search .home-btn {
  margin-top: 1px;
}
</style>
<style lang="less" scoped>
.home-top-list {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  .top-animation {
    animation: opacity2 0.2s;
    -webkit-animation: opacity2 0.2s;
    -moz-animation: opacity2 0.2s;
  }
  .top-animation2 {
    animation: opacity2 0.6s;
    -webkit-animation: opacity2 0.6s;
    -moz-animation: opacity2 0.6s;
  }
  .top-animation3 {
    animation: opacity2 1s;
    -webkit-animation: opacity2 1s;
    -moz-animation: opacity2 1s;
  }
  .top-animation4 {
    animation: opacity2 1.4s;
    -webkit-animation: opacity2 1.4s;
    -moz-animation: opacity2 1.4s;
  }
  @keyframes opacity2 {
    0% {
      top: 0;
      opacity: 0;
    }
    100% {
      top: -100px;
      opacity: 1;
    }
  }
  .top-list {
    z-index: 2;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .top-item {
      margin: 0 10px;
      // min-width: 260px;
      width: 25%;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .home-body {
    z-index: 2;
    position: absolute;
    top: 500px;
    left: 50%;
    width: 100%;
    transform: translate(-50%, 0);
    .news-title {
      width: 100%;
      height: 85px;
      color: #161616;
      font-size: 28px;
      text-align: center;
    }
    .news {
      margin: 0 auto;
      width: 90%;
      max-width: 1440px;
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      li {
        margin: 12px 0;
        width: 24%;
        .item {
          width: 100%;
          height: 346px;
          .img-box {
            width: 100%;
            height: 200px;
            overflow: hidden;
            img {
              object-fit: cover;
              width: 100%;
              height: 200px;
              display: block;
              transition-property: width, height, transform;
              transition-duration: 1s;
              &:hover {
                cursor: pointer;
                opacity: 0.9;
                width: 120%;
                height: 110%;
                transform: translate(-5%, -5%);
              }
            }
          }
          .describe {
            width: 100%;
            padding: 8px 16px;
            box-sizing: border-box;
            background: #ffffff;
            .describe-title {
              display: flex;
              align-items: center;
              width: 100%;
              height: 80px;
              color: #161616;
              font-size: 20px;
              overflow: hidden;
            }
            .abstract {
              width: 100%;
              height: 50px;
              color: #cccccc;
              font-size: 15px;
              overflow: hidden;
            }
          }
        }
      }
      .box-big {
        width: 100%;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.3);
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
      }
    }
  }
}
.switch-con {
  position: fixed;
  top: 22px;
  right: 20px;
  z-index: 1000;
  color: white;
  span {
    cursor: pointer;
  }
}
.home-top {
  width: 100%;
  font-size: 26px;
  text-align: center;
  margin-bottom: 0px;
}
.home-btn2 {
  margin-left: 10px;
  width: 220px;

  .el-button {
    width: 220px !important;
    color: rgb(91, 155, 213);
  }
}
.home-btn2 img {
  vertical-align: text-top;
}
.home-bottom {
  width: 100%;
  padding: 20px;
  background: linear-gradient(116.69deg, #000 -86.16%, #00a2ff 56.2%);
  .home-bottom-wrap {
    width: 80%;
    margin: 0 auto;
  }
  .home-bottom-title {
    color: #fff;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .home-bottom-span {
    color: #fff;
    line-height: 1.5;
  }
}
.link-list {
  display: flex;
  width: 900px;
  margin: auto;
  justify-content: space-around;
  .link-item {
    width: 360px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
    &:hover {
      cursor: pointer;
      box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
    }
    img {
      width: 100%;
    }
  }
  .list-details {
    padding: 12px;
    h3 {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue